import type { PropsWithChildren, ReactNode } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { LoginFailStatus } from "../../enums";
import { NotAuthenticatedInfo } from "../NotAuthenticatedInfo";
import { useAuthTokensContext } from "~/context";



export function AuthenticatedContent({
  children,
}: Readonly<PropsWithChildren<ReactNode>>) {
  const location = useLocation();
  const { addToast } = useToasts();

  const { isAuthenticated } = useAuthTokensContext();

  // handle login failure status url param
  useEffect(() => {
    const urlParams = location.search.slice(1);
    const params = new URLSearchParams(urlParams);
    const status = params.get("status") as LoginFailStatus;
    const autoDismissTimeout = 15_000;

    if (!isAuthenticated) {
      return;
    }

    switch (status) {
      case LoginFailStatus.REDIRECT_NOT_ALLOWED:
        addToast("You are not allowed to view this content", {
          appearance: "warning",
          autoDismissTimeout,
        });
        break;

      case LoginFailStatus.ASSET_NOT_FOUND:
        addToast("The requested content does not exist", {
          appearance: "warning",
          autoDismissTimeout,
        });
        break;
    }
  }, [location, isAuthenticated, addToast]);

  if (!isAuthenticated) {
    return <NotAuthenticatedInfo />;
  }

  // NOTE: fragment used here to ensure we return a JSX.Element type
  return <>{children}</>;
}
